module.exports = __webpack_public_path__ + "images/addMinorPNG_fe3cf52.png";